import React, { useState } from "react";
import { withRouter, Link, useParams, useHistory } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { postAcceptInvite } from "../../helpers/fakebackend_helper";
import AuthShell from "./AuthShell";
import AuthField from "./AuthField";

const AcceptInvite = () => {
  const { token } = useParams();
  const history = useHistory();
  const [error, setError] = useState("");

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { name: "", password: "", confirm: "" },
    validationSchema: Yup.object({
      name: Yup.string().min(2, "At least 2 characters").required("Required"),
      password: Yup.string().min(8, "At least 8 characters").required("Required"),
      confirm: Yup.string().oneOf([Yup.ref("password")], "Passwords do not match").required("Required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setError("");
      try {
        await postAcceptInvite(token, { name: values.name, password: values.password });
        history.push("/login?invited=1");
      } catch (err) {
        setError(typeof err === "string" ? err : "Failed to accept invite.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  document.title = "Accept Invite | BiorGov Admin";

  return (
    <AuthShell
      title="Activate your account"
      subtitle="Set your name and a password to finish setting up."
      footer={<>Already activated? <Link to="/login" style={{ color: "var(--bl-accent-light)" }}>Sign in</Link></>}
    >
      {error && <div className="alert alert-danger" style={{ marginBottom: "1rem" }}>{error}</div>}
      <form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
        <AuthField
          label="Your name"
          name="name"
          type="text"
          autoComplete="name"
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.name}
          error={validation.errors.name}
          touched={validation.touched.name}
        />
        <AuthField
          label="Password"
          name="password"
          type="password"
          autoComplete="new-password"
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.password}
          error={validation.errors.password}
          touched={validation.touched.password}
        />
        <AuthField
          label="Confirm password"
          name="confirm"
          type="password"
          autoComplete="new-password"
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.confirm}
          error={validation.errors.confirm}
          touched={validation.touched.confirm}
        />
        <button type="submit" className="bl-btn-primary" style={{ width: "100%", padding: "0.7rem 1rem" }} disabled={validation.isSubmitting}>
          {validation.isSubmitting ? "Activating…" : "Activate account"}
        </button>
      </form>
    </AuthShell>
  );
};

export default withRouter(AcceptInvite);
